import React from "react";

import { PageBottomContentsContainer } from "./LayoutStyling";

const PageBottomContents = ({ children }) => {
  return <PageBottomContentsContainer>{children}</PageBottomContentsContainer>;
};

export default PageBottomContents;
